export const PTA_PROTOCOL_ITEMS = [
    // 0: Job Header
    {
        id: 0,
        type: 'header',
        title: "Job Descriptions",
        position: "Physical Therapy Assistant",
        reportsTo: "Physical Therapist or Rehab Supervisor"
    },
    // 1: Job Description Summary
    {
        id: 1,
        type: 'text_block',
        title: "JOB DESCRIPTION SUMMARY:",
        text: "The physical therapy assistant provides physical therapy services under the direction of the physical therapist and according to the physician's plan of care."
    },
    // 2: Essential Job Functions/Responsibilities
    {
        id: 2,
        type: 'section',
        title: "ESSENTIAL JOB FUNCTIONS/RESPONSIBILITIES:",
        duties: [
            "Provides direct physical therapy according to directions of physical therapist and in accordance with the physician's plan of care.",
            "Treats patient to relieve pain, develop or restore function, and maintain maximum performance.",
            "Directs and aids patients in active and passive therapeutic exercises, muscle reeducation, gait and functional training, transfer activities and prosthetic training.",
            "Utilizes physical agents, including, but not be limited to heat, cold, water, light, electricity, ultrasound and massage.",
            "Observes and reports to the physical therapist and the Organization personnel the patient's reaction to treatment and any changes in patient's condition.",
            "Instructs patients in care and use of wheelchairs, braces, crutches, canes, and prosthetic or orthotic devices.",
            "Maintains necessary records; clinical notes and conference notes, which will be incorporated into the patient's clinical record in prescribed time frames.",
            "Participates in Organization Home Care Team Members meetings and Organization Inservice Education Program.",
            "Performs other duties as assigned."
        ]
    },
    // 3: Position Qualifications
    {
        id: 3,
        type: 'section',
        title: "POSITION QUALIFICATIONS:",
        list: [
            "Graduate of an accredited physical therapy assistant program with either an Associate's degree in science or applied science that is approved by American Physical Therapy Association, Inc.",
            "Current certification or license as required by state law.",
            "Possesses and maintains current CPR certification.",
            "Must be a licensed driver with an automobile that is insured in accordance with state or organization requirements and is in good working order."
        ]
    },
    // 4: Signature Block
    {
        id: 4,
        type: 'signature',
        fields: [
            { label: "Employee Signature", name: "employeeSignature" },
            { label: "Date", name: "signatureDate", inputType: "date" }
        ]
    },
    // 5: Footer
    {
        id: 5,
        type: 'footer',
        text: "Joint Commission Home Health Human Resource/revised October 2012",
        copyright: "© 1995 The Corridor Group, Inc."
    }
];
